import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
} from "../services/types/ComponentTypes";

export const screen_159_close_jobcard: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Close job",
    BindValue: "con_vehicle_approval",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "job_approval_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_job_approval",
        DisplayName: "Job Approval",
        Workflow: "service",
        DisableSubmit: true,
        BindValue: "job_approve_add",
        SubmitActions: [
          {
            Action: "Navigate",
            Navigate: "modulev1/vehicleinsummary",
          },
        ],
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 16,
          borderRadius: 12,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 16,
              gap: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Back",
                Label: "Back",
                BindValue: "btn_add",
                onPressAction: "navigate",
                Navigate: "modulev1/vehicleinsummary",
                ActionType: "Navigate",
                style: {
                  backgroundColor: "var(--primary-dark)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Edit",
                Label: "Edit",
                BindValue: "btn_Edit",
                onPressAction: "edit",
                ScreenId: "159",
                ActionType: "Edit",
                LockBinding: true,
                Enabled: {
                  Enable: {
                    Json_Attribute: "current_state",
                    values: [
                      "Estimated",
                      "Jobcard",
                      "Approved",
                      "Rejected",
                      "Put on hold",
                    ],
                  },
                  Mode: ["View"],
                },
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                ScreenId: "159",
                ActionType: "Unlock",
                LockBinding: true,
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Approval Details",
            BindValue: "con_approval_details",
            style: {
              direction: FlexDirection.COLUMN,
              gap: 16,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "VIN No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                IsReadOnly: true,
                LookupName: "close_job_no",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Status",
                BindValue: "job_close_status",
                Json_Attribute: "job_close_status",
                componentType: ComponentType.SELECT_DROPDOWN,
                LookupName: "Close",
                IsMandatory: true,
                IsVerticalView: true,
                HideOnStates: ["Closed"],
              },
              {
                Label: "",
                BindValue: "qc_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "close_job_card",
                Parent_Field: "parentid",
              },
            ],
          },
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              marginTop: 24,
              gap: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Submit",
                Label: "Submit",
                BindValue: "btn_submit",
                onPressAction: "save",
                ActionType: "Add",
                ScreenId: "159",
                Enabled: {
                  Enable: {
                    Json_Attribute: "current_state",
                    values: [
                      "Estimated",
                      "Jobcard",
                      "Approved",
                      "Rejected",
                      "Put on hold",
                    ],
                  },
                  Mode: ["Edit", "Add"],
                },
                HideOnStates: ["Closed"],
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Cancel",
                Label: "Cancel",
                BindValue: "btn_cancel",
                onPressAction: "navigate",
                Navigate: "modulev1/vehicleinsummary",
                ActionType: "Navigate",
                style: {
                  backgroundColor: "var(--secondary-gray)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
